import React from 'react';
import { ExactOnlineProductCatalogItemsQueryProvider } from './ExactOnlineProductCatalogItemsQueryProvider';

export const ExactOnlineProductCatalogItemsProviders = ({ children }: any) => {
	return <ExactOnlineProductCatalogItemsQueryProvider>{children}</ExactOnlineProductCatalogItemsQueryProvider>;
};
